<template>
  <div id="why-not-beta">
    <div class="main-container">
      <h2 class="beta__heading heading--md heading--underlined">
        LOOT IS LIFE
      </h2>
      <p class="beta__description">
        <strong>Build your base</strong> from the ground up. Turn the junk you
        found into valuable resources. Use those resources to
        <strong>repair</strong> your damaged gear or try your hand at one of the
        <strong>34 crafting blueprints</strong> available. Equip yourself with
        weapons that suit your gameplay. You can choose from a wide variety of
        <strong>melee weapons</strong> and <strong>military firearms</strong>,
        from pitchfork to heavy machine gun.
        <!-- There are
                <strong>plenty of features we&rsquo;d like to introduce to the game</strong>, with the most important
                one being <strong>multiplayer</strong>. Once we get that up and running, we&rsquo;ll be confident enough
                to consider the game as a proper full release (along with lots of bugfixes). -->
      </p>
      <p class="beta__description">
        <strong>Do you have what it takes to survive?</strong>
      </p>
      <br>
      <p class="beta__description">
        To keep up with all things Mini DayZ, check out our
        <a
          class="color--red external-link"
          href="https://minidayz.com/blog"
          rel="nofollow"
          >blog posts</a
        >
        here on our website, and make sure to follow us on
        <a
          class="color--red external-link"
          href="https://www.facebook.com/MINIDAYZGAME/"
          rel="nofollow noopener noreferrer"
          target="_blank"
          >Facebook</a
        >,
        <a
          class="color--red external-link"
          href="https://twitter.com/minidayzgame"
          rel="nofollow noopener noreferrer"
          target="_blank"
          >Twitter</a
        >, and
        <a
          class="color--red external-link"
          href="https://www.youtube.com/channel/UCVEsMNqwFgoDrgCCSQ-RTfg"
          rel="nofollow noopener noreferrer"
          target="_blank"
          >YouTube</a
        >.
        <!-- But there&rsquo;s still plenty more to come, including bandits, a levelling system, and all kinds of
                cool stuff. If you want to
                <strong>stay informed about the game&rsquo;s ongoing development</strong>, make sure to read our
                <a class="color--red external-link" href="https://minidayz.com/blog" rel="nofollow">blog</a>
                and follow us on
                <a class="color--red external-link" href="https://twitter.com/minidayzgame" rel="nofollow">Twitter</a>. -->
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhyNotBeta"
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/vars";
#why-not-beta {
  padding: 7em 0;
  .beta__heading {
    margin-bottom: em(120, 31);

    @media (max-width: $screen-lg-down) {
      margin-bottom: 1.5em;
    }
  }
  .beta__description {
    font-family: "Metron Book", sans-serif;
    font-size: 1.6em;
    font-weight: 400;
    line-height: 1.7;
    letter-spacing: 0.035em;
  }
}
</style>
